import { Directive, HostListener, Input } from "@angular/core";
import { BrowserService } from "../services/browser.service";
import { IProductMultiLang } from "../models/product";
import { LanguageService } from "projects/shop/src/app/+shared/services/language.service";
import { tap } from "rxjs";
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Directive({
  selector: '[navigateTo]',
  standalone: true
})

export class NavigateToDirective {
  @Input('navigateTo') newUrl!: string;
  @Input() product!: IProductMultiLang

  constructor(
    private _browserService: BrowserService,
    private _languageService: LanguageService,
    private _location: Location,
    private _router: Router
  ) { }



  @HostListener('click')
  navigator() {
    let urlData = this.extractUrl(this.product);
    let { url, same } = urlData;
    if (!same) {
      if (this.product) this._location.go(url);
      else this._router.navigate([url])
    }
  }

  extractUrl(product: IProductMultiLang): ({ url: string, same: boolean }) {
    let location = this._browserService.getLocation()?.pathname;
    let lang = '';
    // ! Get Active APP Lang
    this._languageService.arabic.pipe(
      tap(
        res => {
          lang = res ? 'ar' : 'en'
        }
      )
    ).subscribe()

    let url = '';
    // ! Variables
    if (product) {
      let mainCategorySlug = product.mainCategory?.slug;
      let categorySlug = product.category?.slug;
      let subCategorySlug = product.subCategory?.slug;
      let productSlug = product.slug
      // ! URL Ready To Work
      url = `/${lang}/categories/${mainCategorySlug}/${categorySlug}/${subCategorySlug}/${productSlug}`
    }

    return {
      url: url ? url : this.newUrl,
      same: (url || this.newUrl) == location
    }
  }
}